// extracted by css-extract-rspack-plugin
export default {"image":"_e4ba81ca"};